import { TextField } from "src/components/FormikComponents/TextField";

interface IDefinitionNameProps {
  initialValue: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const DefinitionName = (props: IDefinitionNameProps): JSX.Element => {
  const { initialValue, value, onChange, disabled } = props;
  const isDirty = initialValue !== value;

  return (
    <TextField
      className={`field textfield definition_name_control ${isDirty ? "dirty" : ""}`}
      label=""
      value={value}
      onChange={(event: any) => onChange(event?.target?.value)}
      meta={{
        initialValue: initialValue,
        touched: isDirty,
      }}
      disabled={disabled}
    />
  );
};
